import { useSelector } from 'react-redux';
import lodash from 'lodash';

export default (...paths) => useSelector(state => paths.map(path => lodash.get(state, path)));
